import { VideoPlayerActionContext } from '../types';
import { registerFilmReviewService } from './services/filmReviewService';
import { registerWatchNextService } from './services/watchNextService';

type Ctx = VideoPlayerActionContext;

export const initServices = (context: Ctx): void => {
  context.commit('setServices', [
    registerWatchNextService(context),
    registerFilmReviewService(context),
  ]);
};

export const destroyServices = (context: Ctx): void => {
  context.state.$_internal.services.forEach(service => service.destroy?.());
  context.commit('setServices', []);
};

export const destroyService = (context: Ctx, serviceName: symbol | string): void => {
  const services = context.state.$_internal.services.filter(service => {
    if (service.name !== serviceName) return true;

    service.destroy?.();
    return false;
  });
  context.commit('setServices', services);
};
